<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "industry",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    },
                    {
                        name: "渗透率",
                        data: "a101",
                        unit: "％"
                    },
                    {
                        name: "营收规模",
                        data: "a102",
                        unit: "亿元"
                    },
                    {
                        name: "商家数",
                        data: "a105",
                        unit: "万家"
                    },
                    {
                        name: "融资事件数量",
                        data: "a129",
                        unit: "次"
                    },
                    {
                        name: "融资金额",
                        data: "a130",
                        unit: "亿元"
                    },
                ],
                name: '产业电商'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    },
}
</script>